import { SearchCategory, adminTab } from '~/types/enum';

export const tabs = [
  adminTab.school,
  adminTab.cramSchools,
  adminTab.InternetResource,
  adminTab.record,
];

export const initTabsCategory = {
  [adminTab.school]: SearchCategory.SCHOOL,
  [adminTab.cramSchools]: SearchCategory.CRAM_SCHOOL,
  [adminTab.InternetResource]: SearchCategory.SCHOOL,
};

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 50, 100, 500, 1000];

export const HEADERS = {
  resource: [
    { title: '類別', property: 'categories' },
    { title: '上傳時間', property: 'createdAt' },
    { title: '版本', property: 'versions' },
    { title: '學年度', property: 'years' },
    { title: '學制', property: 'eduCodes' },
    { title: '科目', property: 'subjects' },
    { title: '年級', property: 'grades' },
    { title: '資源類別 1', property: 'resource1' },
    { title: '資源類別 2', property: 'resource2' },
    { title: '資源類別 3', property: 'resource3' },
    { title: '章節關鍵字', property: 'chapterKeyword' },
    { title: '知識點', property: 'knowledge' },
    { title: '顯示名稱', property: 'displayName' },
    { title: '檔名', property: 'fileName' },
  ],
  InternetResource: [
    { title: '類別', property: 'category' },
    { title: '學年度', property: 'years' },
    { title: '學制', property: 'eduCodes' },
    { title: '科目', property: 'subjects' },
    { title: '年級', property: 'grades' },
    { title: '資源類別 1', property: 'resource1' },
    { title: '資源類別 2', property: 'resource2' },
    { title: '資源名稱', property: 'urlName' },
    { title: 'URL', property: 'url' },
    { title: '', property: 'edit' },
  ],
  record: [{ title: '紀錄時間', property: 'recordAt' }],
};

export const WIDTHS = {
  resource: [40, 40, 75, 30, 52, 30, 40, 40, 72, 72, 72, 72, 70, 72, 0],
  InternetResource: [40, 40, 55, 30, 40, 40, 70, 100, 187, 187, 0],
};

export const MOCK_RECORDS = [
  {
    disabled: false,
    createdAt: '2023-09-02T01:40:39.120Z',
    updatedAt: '2023-09-02T01:40:39.120Z',
    _id: '1',
    originalName: 'abc',
    gcsFileName: 'abc1',
    recordTime: '2023-09-02T01:40:39.120Z',
    url: '',
  },
  {
    disabled: false,
    createdAt: '2024-05-02T01:40:39.120Z',
    updatedAt: '2024-05-02T01:40:39.120Z',
    _id: '2',
    originalName: 'cde',
    gcsFileName: 'cde2',
    recordTime: '2024-05-02T01:40:39.120Z',
    url: '',
  },
];

export const HEADER_WIDTH = (
  index: number,
  tab: keyof typeof WIDTHS = 'resource',
) => {
  const sum = WIDTHS[tab].reduce((acc, cur) => acc + cur, 0);
  return {
    maxWidth: `${(WIDTHS[tab][index] / sum) * 100}%`,
    width: `${(WIDTHS[tab][index] / sum) * 100}%`,
    minWidth: `${(WIDTHS[tab][index] / sum) * 100}%`,
  };
};

export const FileFieldText = {
  id: 'id',
  categories: '類別',
  category: '類別', // InternetResource
  versions: '版本',
  years: '學年度',
  eduCodes: '學制',
  subjects: '科目',
  grades: '年級',
  resources1: '資源類別1',
  resources2: '資源類別2',
  resources3: '資源類別3',
  fileName: '檔名',
  chapterKeyword: '章節關鍵字',
  urlName: '資源名稱', // InternetResource
  URL: 'URL', // InternetResource
};
